import React, { useEffect, useState } from 'react'
import { CButton, Loading } from '../../Components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAdminPlans } from '../Services/Plans';
import AdminNavbar from '../Navbar/AdminNavbar';
import { Button, Form, InputGroup } from 'react-bootstrap';
import MakePagination from '../../Components/MakePagination';
import { urlPrefix } from '../../Helpers/Common';
import { useDebounce } from '../../../CustomHooks/DebounceHook';

const ListPlans = () => {
    const navigate = useNavigate()
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [plans, setPlans] = useState([]);
    const [totalPlans, setTotalPlans] = useState(0);
    const [pagination, setPagination] = useState({ limit: 10, start_from: 0, search: null, order_by: [{ column: 'plans.id', order: 'desc' }] });
    const debouncedSearch = useDebounce(search,500);

    const selectFilter = (filter, data) => {
        if (filter === "order") {
            setPagination({ ...pagination, order_by: [data] })
        }
        else if (filter === "pagination") {
            setPagination({ ...pagination, start_from: data })
        }
        else if (filter === "search") {
            setPagination({ ...pagination, start_from: 0, search: data && data.length ? data.trim() : null })
        }
    }

    const getInitialPageData = async () => {
        setLoading(true)
        const result = await getAdminPlans({ ...pagination, plan_details_child_form: true, total_count_of: "plan_details.id" });
        setPlans(result.data.plans)
        setTotalPlans(result.data.totalPlanRecords)
        setLoading(false)
    }

    useEffect(() => {
        getInitialPageData()
    }, [pagination])

    useEffect(()=>{ 
        selectFilter("search",search)
    },[debouncedSearch])

    return (
        <div className="admin-panel-main">
            <div className="panel-row">
                <div className="left">
                    <AdminNavbar></AdminNavbar>
                </div>
                <div className="right">
                    <div className="panel-title-top all-book">
                        <div className="top-left">
                            <h3 className="heading-h3">Plans list</h3>
                        </div>
                        <div className="top-right admin-filter">
                            <div className="right-side">
                                <CButton fxToRun={() => { navigate(urlPrefix() + "/admin/plans/insert") }} label="Add Plan" custClassName="login-button t-btn"></CButton>
                            </div>
                        </div>
                    </div>

                    <div className="dash-filter filter">
                        <div className="left-fil" />
                        <div className="search">
                            <InputGroup className="admin-search-input" onChange={(e) => setSearch(e.target.value)} >
                                <Form.Control placeholder="Search Plan name" value={search || ""} />
                            </InputGroup>
                        </div>
                    </div>

                    <div className="admin-panel-data">
                        <div className="top-title all-plans">
                            <div className="order-no">
                                <p className="top-t">Plan Name</p>
                            </div>
                            <div className="title">
                                <p className="top-t">Detail</p>
                            </div>
                            <div className="e-status">
                                <p className="top-t">Status</p>
                            </div>
                            <div className="e-edit-delete">
                                <p className="top-t">Actions</p>
                            </div>
                        </div>
                        <div className="book-list">
                            {
                                plans && plans.length ?
                                    plans.map((plan) => <div className="book-row all-plans" key={plan.plan_detail_id}>
                                        <div className="order-no-value">
                                            <p className="top-value">{plan.name}</p>
                                        </div>
                                        <div className="title-value">
                                            <p className="top-value">{plan.plan_details.map((item)=>item.description).join(", ")}</p>
                                        </div>
                                        <div className="e-status-value">
                                            <button className={plan.status ? "toggle-on" : "toggle-off"}>
                                            </button>
                                            <div className="d-none">
                                                {
                                                    plan.status ? <div className="on">on</div> : <div className="off">of</div>
                                                }
                                            </div>
                                        </div>
                                        <div className="e-edit-delete-value">
                                            <a className="edit-action" onClick={() => navigate(urlPrefix() + `/admin/plans/edit/${plan.plan_id}`)}><img src={urlPrefix() + "/assets/image/edit-green.png"} alt='book-image' /></a>
                                            {/* <a className="delete-action" href="#"><img src={urlPrefix() + "/assets/image/trash.svg"} alt='book-image' /></a> */}
                                        </div>
                                    </div>) :
                                    <div className='no-data'>
                                        No Plans found.
                                    </div>
                            }

                            {
                                plans && plans.length ?
                                    <div className="books-pagination">
                                        <MakePagination totalRecords={totalPlans} limiter={10} selectFilter={selectFilter}></MakePagination>
                                    </div> : null
                            }

                        </div>
                    </div>
                </div>
            </div>
            {
                loading ? <Loading /> : null
            }
        </div>
    )
}

export default ListPlans
